<template>
  <div>


    <div class="container" style="margin-top: 5%">
      <div class="columns" style="height: 600px">
        <div class="column">
          <div class="box ml-5" style="width: 150%; height: 100%">
            <img :src="require('@/assets/gifs/forget-pwd.gif')" alt="signup-gif" style="height: 550px;" align="left">
          </div>
        </div>
        <div class="column">
          <div class="box-1" style="height: 105%; margin-top: -2%">
            <div style="width: 90%">
              <p class="signIn is-size-1">Create New Password</p>
              <p style="color: #8C8C9B">Your new password should contain uppercase and lowercase letters, numbers, and special characters. </p>
              <div class="mt-5">
                <b-field
                    :type="invalidPassword == '' ? '' : 'is-danger'"
                    :message="invalidPassword"
                    style="text-align: left"
                    label="Enter Your Password"
                    :label-position="labelPosition"
                >
                  <b-input
                      type="password"
                      v-model="password"
                      placeholder="*********"
                      rounded
                      password-reveal
                      @input="resetInvalidStatus('invalidPassword')"
                  ></b-input>
                </b-field>
              </div>

              <div class="mt-3">
                <b-field
                    :type="invalidConfirmPassword == '' ? '' : 'is-danger'"
                    :message="invalidConfirmPassword"
                    style="text-align: left"
                    label="Re-Enter Your Password"
                    :label-position="labelPosition"
                >
                  <b-input
                      type="password"
                      v-model="confirmPassword"
                      placeholder="*********"
                      rounded
                      password-reveal
                      @input="resetInvalidStatus('invalidConfirmPassword')"
                  ></b-input>
                </b-field>
              </div>
              <br />

              <div class="mt-3" style="padding-bottom: 20%">
                <div class="buttons">
                  <b-button type="is-primary" outlined rounded expanded :loading="formIsSubmitting" @click="validateAndSubmit">Confirm</b-button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



</template>

<script>

import axios from "axios";


export default {
  name:"createnew-password",

  components:{

  },

  props:['userid'],

  data(){
    return{

      password:'',
      confirmPassword:'',

      labelPosition: "on-border",

      invalidPassword:'',
      invalidConfirmPassword:'',

      formIsInvalid: false,
      formIsSubmitting: false,
      regex:{
        password:/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,

      },
    }
  },

  methods:{

    validateForm:function () {

      var formIsValid = true
      //ns
      //password
      if(this.password =='' || this.password.indexOf(' ') >= 0){
        this.invalidPassword = 'Password cannot be empty'
        formIsValid = false
      }else if(this.password.length < 8){
        this.invalidPassword = 'Password must be at least 8 characters'
        formIsValid = false
      }else if(this.password.length > 20){
        this.invalidPassword = 'Password must be 8 - 20 characters'
        formIsValid = false
      }else if(!this.regex.password.test(this.password)){
        this.invalidPassword = 'Password must be contain at least one letter, one number and one special character'
        formIsValid = false
      }

      //confirm password

      if(this.confirmPassword =='' || this.confirmPassword.indexOf(' ') >= 0){
        this.invalidConfirmPassword = 'Re-Enter Password cannot be empty'
        formIsValid = false
      }else if(this.password != this.confirmPassword) {
        this.invalidConfirmPassword = 'Passwords do not match'
        formIsValid = false
      }
      //ns
      //password
      // if(this.formdata.password =='' || this.formdata.password.indexOf(' ') >= 0){
      //   this.invalidPassword = 'This field cannot left blank'
      //   formIsValid = false
      // }

      //confirm password
      // if(this.formdata.passwordConfirm =='' || this.formdata.passwordConfirm.indexOf(' ') >= 0){
      //   this.invalidConfirmPassword = 'This field cannot left blank'
      //   formIsValid = false
      // }
      // else if(this.formdata.password != this.formdata.passwordConfirm)
      // {
      //   this.invalidConfirmPassword = 'Password validation failed'
      //   formIsValid = false
      // }

      if(formIsValid){
        return true
      }
      else{
        return false
      }

    },


    submitForm:function (){
      var component = this
      component.formIsSubmitting = true
      axios.post(component.$base_url+'/agent/resetpassword', {
        password:component.password,
        user_id:component.userid

      })
          .then(function (data) {
            var array =[]
            array = data.data

            console.log(array.data.message)
            if(array.success == true){
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-success'
              })
              component.formIsSubmitting = false
              component.$router.push({name:'agentSignin'})
            }else{
              component.$buefy.toast.open({
                message: array.data.message,
                type: 'is-danger'
              })
              component.formIsSubmitting = false
            }

          })
          .catch(function (error) {
            console.log(error)
          });
    },

    resetInvalidStatus: function(key){

      this[key] = ''
      this.formIsInvalid = false


    },

    validateAndSubmit: function(){
      if(this.validateForm()){
        this.submitForm()
      }
      else{
        this.formIsInvalid = true
      }
    },



  }
}
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .box{
    display: none;
  }

}

.signIn {
  padding-top: 30px;
  font-weight: bold;
  background: -webkit-linear-gradient(#3a8fff 0 30%, #0837ae 55% 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

p {
  color: gray;
  font-weight: 500;
}
.link {
  color: #0d5da3;
  text-decoration: underline;
  cursor: pointer;
}
.link:hover {
  color: #092bc2;
  text-shadow: 1px;
}

.box-1 {
  position: relative;
  z-index: 1;
  background-color: white;
  border-radius: 0 15px 15px 0;
  box-shadow: 0 -5px 5px -5px #333, 5px 0 5px -5px #333, 0 5px 5px -5px #333;
}
.box-1::before {
  position: absolute;
  left: -5%;
  content: "";
  width: 70px;
  z-index: -1;
  height: 100%;
  background-color: inherit;
  border-radius: 15px 0 0 15px;
  box-shadow: 0 -1px 5px -5px #333, -5px 0 5px -5px #333, 1px 5px 0px -5px #333;
  /* box-shadow: 0px 10px 0px 0 rgb(41, 33, 33); */
  transform: skew(-5deg);
}
</style>
